import React from "react"

export const FilledIconPravdaCoffee = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 6C2 3.79086 3.79086 2 6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6Z"
      fill="#FF4E50"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3331 8.89418C16.5755 9.17127 16.5475 9.59244 16.2704 9.8349L10.9593 14.4821C10.8972 14.5412 10.8266 14.5861 10.7514 14.6167C10.4949 14.7221 10.1891 14.6592 9.99632 14.4388C9.99584 14.4383 9.99537 14.4378 9.9949 14.4372L8.02827 12.4706C7.76792 12.2102 7.76792 11.7881 8.02827 11.5278C8.28862 11.2674 8.71073 11.2674 8.97108 11.5278L10.5296 13.0863L15.3924 8.83146C15.6695 8.58901 16.0906 8.61709 16.3331 8.89418Z"
      fill="white"
    />
  </svg>
)
